/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AppliedContractTermsResource } from './';
import {
    AppliedContractTermsResourceFromJSON,
    AppliedContractTermsResourceFromJSONTyped,
    AppliedContractTermsResourceToJSON,
} from './';
import type { ContractInvoicingModeResource } from './';
import {
    ContractInvoicingModeResourceFromJSON,
    ContractInvoicingModeResourceFromJSONTyped,
    ContractInvoicingModeResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface TermsResource
 */
export interface TermsResource {
    /**
     * 
     * @type {AppliedContractTermsResource}
     * @memberof TermsResource
     */
    current: AppliedContractTermsResource;
    /**
     * 
     * @type {ContractInvoicingModeResource}
     * @memberof TermsResource
     */
    pending?: ContractInvoicingModeResource;
}

/**
 * Check if a given object implements the TermsResource interface.
 */
export function instanceOfTermsResource(value: object): value is TermsResource {
    if (!('current' in value) || value['current'] === undefined) return false;
    return true;
}

export function TermsResourceFromJSON(json: any): TermsResource {
    return TermsResourceFromJSONTyped(json, false);
}

export function TermsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TermsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'current': AppliedContractTermsResourceFromJSON(json['current']),
        'pending': json['pending'] == null ? undefined : ContractInvoicingModeResourceFromJSON(json['pending']),
    };
}

export function TermsResourceToJSON(value?: TermsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'current': AppliedContractTermsResourceToJSON(value['current']),
        'pending': ContractInvoicingModeResourceToJSON(value['pending']),
    };
}

